import { FieldError } from 'react-hook-form';
import TextSmall from './TextSmall';

export default function ErrorText({ error }: { error: string | FieldError }) {
    return (
        <TextSmall className="lg:text-p max-lg:text-sm text-red line-clamp-1">
            {typeof error === 'string' ? error : `${error.message}`}
        </TextSmall>
    );
}
